import React from "react";
import ConnectedRecurringSummaryCancelContent from "./ConnectedRecurringSummaryCancelContent";
import ConnectedRecurringSummaryCancelModal from "./RecurringSummaryCancelModal";

/**
 * @param {object} props
 * @param {object} props.control
 * @param {boolean} props.displayCancelWidget
 * @param {boolean} props.displayModal
 * @param {Function} props.setDisplayModal
 * @returns {React.JSX.Element}
 */
const RecurringSummaryCancel = ({
    control,
    displayCancelWidget,
    displayModal,
    setDisplayModal,
}) =>
    displayCancelWidget && (
        <>
            <ConnectedRecurringSummaryCancelContent
                control={control}
                setDisplayModal={setDisplayModal}
            />
            {displayModal && (
                <ConnectedRecurringSummaryCancelModal
                    onClose={() => setDisplayModal(!displayModal)}
                />
            )}
        </>
    );

export default RecurringSummaryCancel;
